const loadMoreButton = document.querySelector("#load-more-portfolio");
const portfolioWrapper = document.querySelector(".case-study-grid-row");
const portfolioLoader = document.querySelector(".portfolio-loader");
const industryFilter = document.querySelector("select#industries");
const technologyFilter = document.querySelector("select#technologies");
const loadMoreWrapper = document.querySelector(".load-more-wrapper");

let isResetting = false;

export function portfolioLoadMore() {
    console.log("portfolioLoadMore initialized. Elements found:", {
        loadMoreButton: !!loadMoreButton,
        portfolioWrapper: !!portfolioWrapper,
        industryFilter: !!industryFilter,
        technologyFilter: !!technologyFilter
    });

    if (!loadMoreButton || !portfolioWrapper) {
        console.warn("Required load more elements not found, aborting initialization.");
        return;
    }

    loadMoreButton.addEventListener("click", loadMorePortfolio);

    if (industryFilter) {
        industryFilter.addEventListener("change", handleFilterChange);
    }

    if (technologyFilter) {
        technologyFilter.addEventListener("change", handleFilterChange);
    }

}

async function handleFilterChange(e) {
    console.log("handleFilterChange triggered by:", e ? e.target : "unknown");

    if (isResetting) {
        return;
    }

    if (loadMoreButton.classList.contains("loading")) {
        return;
    }

    const resetSelect = (selectEl) => {
        if (!selectEl) return;
        selectEl.value = "";
        if (selectEl.slim) {
            try {
                if (typeof selectEl.slim.setSelected === "function") {
                    selectEl.slim.setSelected("");
                } else if (typeof selectEl.slim.set === "function") {
                    selectEl.slim.set("");
                }
                console.log("SlimSelect UI updated for element:", selectEl.id);
            } catch (err) {
                console.error("Error updating SlimSelect UI:", err);
            }
        }
    };

    if (e && e.target === industryFilter) {
        if (technologyFilter && technologyFilter.value !== "") {
            isResetting = true;
            resetSelect(technologyFilter);
            isResetting = false;
            console.log("Reset technologyFilter during change event");
        }
    } else if (e && e.target === technologyFilter) {
        if (industryFilter && industryFilter.value !== "") {
            isResetting = true;
            resetSelect(industryFilter);
            isResetting = false;
            console.log("Reset industryFilter during change event");
        }
    }

    loadMoreButton.classList.add("loading");

    if (portfolioLoader) {
        portfolioLoader.style.display = "inline-flex";
    }

    const selectedIndustry = industryFilter ? industryFilter.value : "";
    const selectedTechnology = technologyFilter ? technologyFilter.value : "";

    const formData = new FormData();
    formData.append("page", 1);
    formData.append("per_page", loadMoreButton.dataset.perPage);
    formData.append("technology", selectedTechnology === "all" ? "" : selectedTechnology);
    formData.append("industry", selectedIndustry === "all" ? "" : selectedIndustry);

    try {

        const response = await fetch(loadMoreButton.dataset.url, {
            method: "POST",
            body: formData
        });

        if (!response.ok) {
            throw new Error("Unable to filter portfolios.");
        }

        const result = await response.json();

        if (result.success) {

            if (result.html.trim() === "") {
                portfolioWrapper.innerHTML = '<p class="not-found-text">No any portfolio found</p>';
            } else {
                portfolioWrapper.innerHTML = result.html;
            }

            loadMoreButton.dataset.page = 1;
            loadMoreButton.dataset.technology = selectedTechnology === "all" ? "" : selectedTechnology;
            loadMoreButton.dataset.industry = selectedIndustry === "all" ? "" : selectedIndustry;

            if (window.lazySizes) {
                lazySizes.loader.checkElems();
            }

            if (loadMoreWrapper) {
                if (result.hasMore) {
                    loadMoreWrapper.style.display = "block";
                    loadMoreButton.style.display = "inline-flex";
                } else {
                    loadMoreWrapper.style.display = "none";
                }
            }

        }

    } catch (error) {

        console.error("Portfolio Filter Error:", error);

    } finally {

        loadMoreButton.classList.remove("loading");

        if (portfolioLoader) {
            portfolioLoader.style.display = "none";
        }

    }

}

async function loadMorePortfolio() {

    if (loadMoreButton.classList.contains("loading")) {
        return;
    }

    loadMoreButton.classList.add("loading");

    if (portfolioLoader) {
        portfolioLoader.style.display = "inline-flex";
    }

    const page = parseInt(loadMoreButton.dataset.page, 10) + 1;

    const formData = new FormData();

    formData.append("page", page);
    formData.append("per_page", loadMoreButton.dataset.perPage);
    formData.append("technology", loadMoreButton.dataset.technology || "");
    formData.append("industry", loadMoreButton.dataset.industry || "");

    try {

        const response = await fetch(loadMoreButton.dataset.url, {
            method: "POST",
            body: formData
        });

        if (!response.ok) {
            throw new Error("Unable to load portfolios.");
        }

        const result = await response.json();

        if (result.success) {

            portfolioWrapper.insertAdjacentHTML("beforeend", result.html);

            loadMoreButton.dataset.page = page;

            if (window.lazySizes) {
                lazySizes.loader.checkElems();
            }

            if (loadMoreWrapper) {
                if (result.hasMore) {
                    loadMoreWrapper.style.display = "block";
                    loadMoreButton.style.display = "inline-flex";
                } else {
                    loadMoreWrapper.style.display = "none";
                }
            }

        } else {

            if (loadMoreWrapper) {
                loadMoreWrapper.style.display = "none";
            }

        }

    } catch (error) {

        console.error("Portfolio Load More Error:", error);

    } finally {

        loadMoreButton.classList.remove("loading");

        if (portfolioLoader) {
            portfolioLoader.style.display = "none";
        }

    }

}